import { z } from 'zod';
import { anyProductCursorSchema } from '../const/productCursorSchema';
import { productSortingSchema } from '../const/productSortingSchema';
import { productFilterSchema } from './productFilterSchema';

export const getAllProductSchema = z.object({
    cursor: anyProductCursorSchema.default(null),
    limit: z.number().max(100).default(40),
    search: z.string().optional(),
    listId: z.string().uuid().optional(),
    categoryId: z.string().uuid().optional(),
    filter: productFilterSchema,
    sorting: productSortingSchema,
});

export type GetAllProductSchema = z.infer<typeof getAllProductSchema>;
